import { Title, SubTitle, Paragraph } from '@bidalihq/ui';

import Section from '@/components/section';

const Hero = () => {
  return (
    <Section>
      <Title>About Bidali</Title>
      <SubTitle className="text-brand-primary/95 my-4">We are reimagining digital commerce.</SubTitle>
      <Paragraph >Bidali helps businesses increase sales and eliminate fraud with next generation payments and more flexible gift cards.</Paragraph>
    </Section>
  );
};

export default Hero;
